import * as React from 'react';
import * as styles from './BalloonImage.css';

interface IBalloonImageProps {
  imageUrl: string;
  title: string;
}

export function BalloonImage({ imageUrl, title }: IBalloonImageProps) {
  return <img className={styles['image']} src={imageUrl} alt={title} width={340} height={160} />;
}
